/** The preview's zoom range, shared by the zoom bar and every fit calculation. */
export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 3.0;

export const clampZoom = (zoom: number): number => Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, zoom));
